import { Client } from './client.model';

export class ResaMultiple {
    coursId: string;
    clients: Client[];

}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/resaMultiple.model.ts